export const HOST_API = process.env.REACT_APP_HOST;
export const HOST_REDUTO = process.env.REACT_APP_HOST_REDUTO;
